// Auto-generated by splitter.py — do not regenerate; edit directly.

import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Building2, Calendar, ChevronDown, ChevronRight, Download, FileText, Inbox, Megaphone, Send, ShieldAlert, ShieldCheck, Sparkles, Store } from 'lucide-react';

const QUICK_ACTIONS = [
  { id: 'manual-order', label: 'New manual order',  sub: 'Create order · OTP-gated',            icon: Inbox,         tone: '#1F2937' },
  { id: 'box-office',   label: 'Create box office', sub: 'Box-office wizard',                   icon: Store,         tone: '#1F2937' },
  { id: 'organizer',    label: 'Onboard organizer', sub: 'Creates organization profile records', icon: Building2,     tone: '#1F2937' },
  { id: 'event',        label: 'New event',         sub: 'Event-page creation wizard',          icon: Calendar,      tone: '#1F2937' },
  { id: 'accreditation',label: 'Issue accreditation', sub: 'Accreditation card issuance',       icon: ShieldCheck,   tone: '#1F2937' },
  { id: 'campaign',     label: 'Send campaign',     sub: 'Email / WhatsApp broadcast',          icon: Megaphone,     tone: '#1F2937' },
  // 'New risk case' removed with the fabricated case queue — no backend stores a case.
  { id: 'bank-file',    label: 'Generate bank file', sub: 'Payout bank-file wizard',            icon: FileText,      tone: '#1F2937' },
  { id: 'broadcast',    label: 'Compose broadcast', sub: 'Open the event detail to send',       icon: Send,          tone: '#1F2937' },
  { id: 'export',       label: 'Export data',       sub: 'Filter · columns · CSV / JSON',        icon: Download,      tone: '#1F2937' },
];

export const QuickActionsPopover = ({ onAction }) => {
  const [open, setOpen] = useState(false);
  const actions = QUICK_ACTIONS;

  return (
    <div className="relative">
      {/* OUTLINED, via the console's own Button. It was a ghost button — invisible until hover —
          sitting between a search field and a row of icon buttons, so the one control in the header
          that OPENS things had the least presence of anything there. `secondary` is the console's
          outline: white on a hairline border, present without competing with a primary action.
          The chevron is a child, not the `icon` prop, because Button renders `icon` leading. */}
      <Button
        variant="secondary"
        size="md"
        icon={Sparkles}
        data-quick-actions-trigger="true"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}
      >
        Quick actions
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} />
      </Button>
      {open && (
        <>
          <div className="fixed inset-0 z-[40]" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-[calc(100%+4px)] z-[50] w-[320px] bg-white border border-[#E6E4E1] rounded-[10px] shadow-xl overflow-hidden">
            <div className="px-3 py-2 border-b border-[#EEEDEA] flex items-center justify-between">
              <div className="text-[10.5px] font-semibold tracking-[0.06em] uppercase text-[#6B7280]">Quick actions</div>
              <kbd className="text-[9.5px] text-[#9CA3AF] bg-[#FBFAF7] border border-[#E6E4E1] rounded px-1.5 py-0.5 font-mono">⌘.</kbd>
            </div>
            <div className="max-h-[380px] overflow-y-auto py-1">
              {actions.map(a => {
                const Icon = a.icon;
                return (
                  <button key={a.id} onClick={() => { setOpen(false); onAction && onAction(a.id); }} className="w-full text-left px-3 py-2 hover:bg-[#FBFAF7] flex items-center gap-3">
                    <div className="w-7 h-7 rounded-md bg-[#F2F1ED] text-[#1F2937] flex items-center justify-center flex-shrink-0">
                      <Icon className="w-3.5 h-3.5" strokeWidth={1.75} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-[12.5px] font-medium text-[#1F2937]">{a.label}</div>
                      <div className="text-[10.5px] text-[#6B7280] mt-0.5">{a.sub}</div>
                    </div>
                    <ChevronRight className="w-3.5 h-3.5 text-[#D6D3D1] flex-shrink-0" />
                  </button>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

/* ============================================================================
   VENUES MODULE — rich data structure
   ============================================================================ */
